const PREFIX = 'golaxy_'

export function setStorage(key, value) {
  localStorage.setItem(PREFIX + key, JSON.stringify(value))
}

export function getStorage(key) {
  const value = localStorage.getItem(PREFIX + key)
  return value ? JSON.parse(value) : null
}

export function removeStorage(key) {
  localStorage.removeItem(PREFIX + key)
}

export function clearStorage() {
  Object.keys(localStorage)
    .filter((k) => k.startsWith(PREFIX))
    .forEach((k) => localStorage.removeItem(k))
}
